import removeUrlParam from "./removeUrlParam";
import findUrlParam from "./findUrlParam";

export const hasHtmEnding = slug => slug.indexOf(".htm") !== -1;

const preparePostLink = url => {
	const findParam = "link-target";
	const pureUrl = removeUrlParam(findParam, url);
	return {
		url: pureUrl,
		hasTarget: url !== pureUrl,
		targetValue: findUrlParam(findParam, url),
	};
};

export default preparePostLink;
